import { ColumnDef } from '@tanstack/react-table';

export const getColumnKey = <TData, TValue>(column: ColumnDef<TData, TValue>): string | undefined => {
  if ('accessorKey' in column && typeof column.accessorKey === 'string') {
    return column.accessorKey;
  }
  return column.id;
};
